import { Image } from '@mantine/core';

import expandingBuilding from 'src/assets/images/expanding-building.svg';

import styles from './NotReadyYet.module.scss';

const NotReadyYet = () => {
  return (
    <>
      <div className={styles.title}>Cette fonctionnalité est en cours de développement !</div>
      <div className={styles.container}>
        <Image src={expandingBuilding} className={styles.image} />
        <div className={styles.subtitle}>Elle sera disponible très prochainement.</div>
      </div>
    </>
  );
};

export default NotReadyYet;
